import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { POST_AUDIT_REPORT_LISTING } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  pagination?: {
    page: number;
    size: number;
    order: string;
    sort: string;
  };
  reportType: string;
}

export const usePostAuditReportListing = (
  { onSuccess, onError, pagination, reportType }: Input = { reportType: 'DEFAULT' }
) => {
  const PostAuditReportListing = async () => {
    const res = await axiosClient.post(POST_AUDIT_REPORT_LISTING, null, {
      params: {
        reportType,
        page: pagination?.page || '0',
        size: pagination?.size || '5',
        sort: `${pagination?.sort || 'createdAt'},${pagination?.order || 'desc'}`,
      },
    });
    return res.data;
  };
  return useCustomMutation(PostAuditReportListing, {
    onSuccess,
    onError,
  });
};
